import React, { useState, useEffect } from "react";
import "./../../../../assets/css/purchase/form.css";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import {
  deleteData,
  getAlert,
  getDataWithComp,
  getDataWithJoin,
  insertData,
  parseCurrency,
  updateData,
} from "../../../../utils/SamuiUtils";
import { useNavigate } from "react-router-dom";
import CurrencyInput from "react-currency-input-field";
import ArImage from "../../../components/Modal/ArImage";
import ItemModal from "../../../components/Modal/ItemModal";
const Form = ({
  callInitialize,
  onCancel,
  mode,
  name,
  formData,
  setFormData,
  selectedData,
  dataARtype,
}) => {
  const [initialFormData, setInitialFormData] = useState({});
  const [showIcePriceModal, setShowIcePriceModal] = useState(false);
  const [standardPrice, setStandardPrice] = useState(0);
  const [specialPrice, setSpecialPrice] = useState(0);
  const [isThreeBagDeal, setIsThreeBagDeal] = useState(false);
  const [showPictureModal, setShowPictureModal] = useState(false);
  const [showItemPriceModal, setShowItemPriceModal] = useState(false);
  const [itemDataList, setItemDataList] = useState([]);
  const [itemPriceRows, setItemPriceRows] = useState([]);
  const [rowsToDelete, setRowsToDelete] = useState([]);
  const [showItemModal, setShowItemModal] = useState(false);
  const [isSavingItemPrice, setIsSavingItemPrice] = useState(false);
  const navigate = useNavigate();

  const fetchItemMasterList = async () => {
    try {
      const compId = window.localStorage.getItem("company");
      const response = await getDataWithComp(
        "Tb_Set_Item",
        `AND Comp_Id = ${compId} ORDER BY Item_Code`
      );
      const finalList = Array.isArray(response) ? response : [];
      setItemDataList(finalList);
      return finalList;
    } catch (error) {
      console.error("Error loading item master list:", error);
      setItemDataList([]);
      return [];
    }
  };

  const loadItemPrices = async (currentItems = itemDataList) => {
    try {
      if (!formData.ar_id) {
        setItemPriceRows([]);
        setRowsToDelete([]);
        return [];
      }
      const compId = window.localStorage.getItem("company");
      const response = await getDataWithComp(
        "Tb_Set_Item_Price",
        `AND Comp_Id = ${compId} AND AR_Id = ${formData.ar_id}`
      );
      const finalRows = Array.isArray(response) ? response : [];
      const mappedRows = finalRows.map((row) => {
        const matchedItem = currentItems.find(
          (item) => Number(item.Item_Id) === Number(row.Item_Id)
        );
        return {
          Item_Price_Id: row.Item_Price_Id,
          Item_Id: row.Item_Id,
          Item_Code: matchedItem?.Item_Code || "",
          Item_Name: matchedItem?.Item_Name || "",
          Item_Price: row.Item_Price ?? 0,
        };
      });
      setItemPriceRows(mappedRows);
      setRowsToDelete([]);
      return mappedRows;
    } catch (error) {
      console.error("Error loading item prices:", error);
      setItemPriceRows([]);
      setRowsToDelete([]);
      return [];
    }
  };

  const handleOpenItemPriceModal = async () => {
    if (mode !== "U" || !formData.ar_id) {
      getAlert("WARNING", "กรุณาบันทึกรายการก่อน");
      return;
    }
    const items =
      itemDataList.length > 0 ? itemDataList : await fetchItemMasterList();
    await loadItemPrices(items);
    setShowItemPriceModal(true);
  };

  const handleSelectedItems = (items) => {
    if (!Array.isArray(items) || items.length === 0) {
      setShowItemModal(false);
      return;
    }
    setItemPriceRows((prevRows) => {
      const existingIds = new Set(prevRows.map((row) => row.Item_Id));
      const updatedRows = [...prevRows];
      items.forEach((item) => {
        if (!existingIds.has(item.Item_Id)) {
          updatedRows.push({
            Item_Price_Id: null,
            Item_Id: item.Item_Id,
            Item_Code: item.Item_Code,
            Item_Name: item.Item_Name,
            Item_Price: 0,
          });
        }
      });
      return updatedRows;
    });
    setShowItemModal(false);
  };

  const sanitizeInputToNumber = (value) => {
    const stringValue =
      value === undefined || value === null ? "0" : String(value);
    const cleaned = stringValue.replace(/,/g, "").replace(/[^\d.-]/g, "");
    const parsed = parseFloat(cleaned);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const handleItemPriceChange = (itemId, value) => {
    setItemPriceRows((prevRows) =>
      prevRows.map((row) =>
        row.Item_Id === itemId
          ? { ...row, Item_Price: value === undefined ? 0 : sanitizeInputToNumber(value) }
          : row
      )
    );
  };

  const handleItemPriceFocus = (itemId) => {
    setItemPriceRows((prevRows) =>
      prevRows.map((row) => {
        if (row.Item_Id !== itemId) return row;
        const numericValue = sanitizeInputToNumber(row.Item_Price);
        return {
          ...row,
          Item_Price: numericValue,
        };
      })
    );
  };

  const handleItemPriceBlur = (itemId, value) => {
    setItemPriceRows((prevRows) =>
      prevRows.map((row) => {
        if (row.Item_Id !== itemId) return row;

        const raw = value ?? row.Item_Price;

        let numericValue = 0;
        if (typeof raw === "number") {
          numericValue = raw;
        } else if (typeof raw === "string") {
          const cleaned = raw.replace(/,/g, "").replace(/[^\d.-]/g, "");
          const parsed = parseFloat(cleaned);
          numericValue = Number.isFinite(parsed) ? parsed : 0;
        } else {
          numericValue = 0;
        }

        return {
          ...row,
          Item_Price: numericValue,
        };
      })
    );
  };

  const handleRemoveItemRow = (itemId, priceId) => {
    if (priceId) {
      setRowsToDelete((prev) => [...prev, priceId]);
    }
    setItemPriceRows((prevRows) =>
      prevRows.filter((row) => row.Item_Id !== itemId)
    );
  };

  const handleSaveItemPrices = async () => {
    if (!formData.ar_id) {
      getAlert("WARNING", "กรุณาบันทึกรายการก่อน");
      return;
    }

    if (itemPriceRows.length === 0 && rowsToDelete.length === 0) {
      getAlert("WARNING", "กรุณาเลือกสินค้าอย่างน้อยหนึ่งรายการ");
      return;
    }

    try {
      setIsSavingItemPrice(true);
      const compId = window.localStorage.getItem("company");

      for (const priceId of rowsToDelete) {
        await deleteData(
          "Tb_Set_Item_Price",
          `WHERE Item_Price_Id = ${priceId}`
        );
      }

      for (const row of itemPriceRows) {
        const priceValue = parseCurrency(row.Item_Price) || 0;
        if (row.Item_Price_Id) {
          await updateData(
            "Tb_Set_Item_Price",
            { Item_Price: priceValue },
            { Item_Price_Id: row.Item_Price_Id }
          );
        } else {
          await insertData(
            "Tb_Set_Item_Price",
            "Item_Id, Item_Price, Comp_Id, AR_Id",
            [row.Item_Id, priceValue, compId, formData.ar_id]
          );
        }
      }

      getAlert("OK", "บันทึกราคาสินค้าสำเร็จ");
      await loadItemPrices(itemDataList);
    } catch (error) {
      console.error("Error saving item prices:", error);
      getAlert("FAILED", "ไม่สามารถบันทึกราคาสินค้าได้");
    } finally {
      setIsSavingItemPrice(false);
    }
  };

  const closeItemPriceModal = () => setShowItemPriceModal(false);

  useEffect(() => {
    fetchItemMasterList();
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (
        showIcePriceModal ||
        showPictureModal ||
        showItemPriceModal ||
        showItemModal
      )
        return;

      if (
        document.activeElement.tagName === 'INPUT' ||
        document.activeElement.tagName === 'TEXTAREA' ||
        document.activeElement.tagName === 'SELECT'
      ) {
        return;
      }

      switch (event.key) {
        case 'Escape':
          event.preventDefault();
          onCancel?.();
          break;
        case 'F10':
          event.preventDefault();
          if (mode === "I") {
            confirmAndSubmit();
          } else if (mode === "U") {
            confirmAndUpdate();
          }
          break;
        default:
          break;
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };

  }, [
    mode,
    formData.ar_id,
    showIcePriceModal,
    showPictureModal,
    showItemPriceModal,
    showItemModal,
    onCancel,
  ]);

  useEffect(() => {
    const compId = localStorage.getItem("company");
    if (compId) {
      setFormData((prevData) => ({
        ...prevData,
        comp_id: compId,
      }));
    }
  }, [setFormData]);

  useEffect(() => {
    if (mode === "I") {
      const initialData = {
        ar_id: "",
        comp_id: window.localStorage.getItem("company"),
        ar_code: "",
        ar_name: "",
        ar_type: "",
        ar_shortname: "",
        ar_taxno: "",
        ar_add1: "",
        ar_add2: "",
        ar_add3: "",
        ar_province: "",
        ar_zipcode: "",
        ar_contact1: "",
        ar_contact2: "",
        ar_tel1: "",
        ar_tel2: "",
        ar_group: "",
        ar_refsalecode: "",
        ar_area: "",
        ar_status: "Y",
        ar_credit: 0,
        ar_vat: 0,
        ar_discount: "",
        ar_branch: "",
        ar_bt_name: "",
        ar_addlan: "",
        ar_addlat: "",
        ar_refsalename: "",
        ar_credit_term: "",
        ar_credit_limit: "",
        ar_item_free: "N",
      };
      setFormData(initialData);
      setInitialFormData(initialData);
    } else if (mode === "U") {
      const initialData = {
        ar_id: selectedData.AR_Id,
        comp_id: window.localStorage.getItem("company"),
        ar_code: selectedData.AR_Code,
        ar_name: selectedData.AR_Name,
        ar_type: selectedData.AR_Type,
        ar_shortname: selectedData.AR_ShortName,
        ar_taxno: selectedData.AR_TaxNo,
        ar_add1: selectedData.AR_Add1,
        ar_add2: selectedData.AR_Add2,
        ar_add3: selectedData.AR_Add3,
        ar_province: selectedData.AR_Province,
        ar_zipcode: selectedData.AR_Zipcode,
        ar_contact1: selectedData.AR_Contact1,
        ar_contact2: selectedData.AR_Contact2,
        ar_tel1: selectedData.AR_Tel1,
        ar_tel2: selectedData.AR_Tel2,
        ar_group: selectedData.AR_Group,
        ar_refsalecode: selectedData.AR_RefSaleCode,
        ar_area: selectedData.AR_Area,
        ar_status: selectedData.AR_Status,
        ar_credit: parseCurrency(selectedData.AR_Credit, 10),
        ar_vat: parseCurrency(selectedData.AR_Vat, 10),
        ar_discount: selectedData.AR_Discount,
        ar_branch: selectedData.AR_Branch,
        ar_bt_name: selectedData.AR_BT_Name,
        ar_addlan: selectedData.AR_ADDLAN,
        ar_addlat: selectedData.AR_ADDLAT,
        ar_refsalename: selectedData.AR_RefSaleName,
        ar_credit_term: selectedData.AR_Credit_Term,
        ar_credit_limit: selectedData.AR_Credit_Limit,
        ar_item_free: selectedData.AR_Item_Free,
      };
      setFormData(initialData);
      setInitialFormData(initialData);
    }
  }, [mode, setFormData, selectedData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "ar_taxno") {
      if (/^\d*$/.test(value) && value.length <= 13) {
        setFormData({
          ...formData,
          [name]: value,
        });
      }
    } else if (name === "ar_zipcode") {
      if (value.length <= 5) {
        setFormData({
          ...formData,
          [name]: value,
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };
  const handleCurrencyChange = (value, name) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleInsertAR = async () => {
    try {
      const { ar_id, ...dataToInsert } = formData;

      const sanitizeData = (data) => {
        const sanitized = { ...data };
        sanitized.ar_credit = data.ar_credit === "" ? 0 : data.ar_credit;
        sanitized.ar_vat = data.ar_vat === "" ? 0 : data.ar_vat;
        sanitized.ar_discount = data.ar_discount === "" ? 0 : data.ar_discount;
        sanitized.ar_credit_term =
          data.ar_credit_term === "" ? 0 : data.ar_credit_term;
        sanitized.ar_credit_limit =
          data.ar_credit_limit === "" ? 0 : data.ar_credit_limit;
        sanitized.ar_item_free = data.ar_item_free ? "N" : data.ar_item_free;
        return sanitized;
      };

      const sanitizedData = sanitizeData(dataToInsert);

      const fields = Object.keys(sanitizedData).join(", ");
      const values = Object.values(sanitizedData);

      const res = await insertData("Tb_Set_AR", fields, values);

      if (res?.status === "OK") {
        getAlert("OK", "บันทึกสำเร็จ");
        callInitialize();
      } else {
        getAlert("FAILED", res?.message || "ไม่สามารถบันทึกข้อมูลได้");
      }
    } catch (error) {
      console.error("Error inserting data:", error);
      getAlert(
        "FAILED",
        "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว"
      );
    }
  };

  const formatValues = (data) => {
    const { ar_id, ...rest } = data;
    return rest;
  };

  const handleUpdateAR = async () => {
    try {
      const where = { ar_id: formData.ar_id };
      const values = formatValues(formData);
      const res = await updateData("Tb_Set_AR", values, where);
      if (res) {
        getAlert("OK", "อัปเดตข้อมูลสำเร็จ");
        callInitialize(formData.ar_id ?? selectedData?.Ar_Id ?? selectedData?.AR_Id);
      }
    } catch (error) {
      getAlert(
        "FAILED",
        "ไม่สามารถอัปเดตข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว"
      );
      return null;
    }
  };

  const handleDelete = async () => {
    try {
      getAlert("C_DIALOG", "ยืนยันการลบข้อมูล", async (isConfirm) => {
        if (isConfirm) {
          await deleteData("Tb_Set_AR", `WHERE AR_Id = ${selectedData.AR_Id}`);
          getAlert("OK", "ลบข้อมูลสำเร็จ");
          await callInitialize();
        }
      });
    } catch (error) {
      getAlert("FAILED", "ไม่สามารถลบข้อมูลได้ กรุณาลองใหม่อีกครั้ง");
    }
  };

  const handleSubmit = async (e) => {
    try {
      if (
        !formData.ar_code ||
        !formData.ar_name ||
        !formData.ar_type ||
        !formData.ar_status
      ) {
        getAlert(
          "WARNING",
          "โปรดกรอกข้อมูล รหัสลูกหนี้ ชื่อลูกหนี้ ประเภทลูกหนี้ สถานะ"
        );
        return;
      }

      // เช็กข้อมูลซ้ำในฐานข้อมูลก่อนบันทึก
      const existingData = await getDataWithComp(
        "Tb_Set_AR",
        `AND AR_Name = '${formData.ar_name}'`
      );

      if (existingData && existingData.length > 0) {
        return getAlert(
          "FAILED",
          "ไม่สามารถบันทึกได้ เนื่องจากมีลูกค้าชื่อนี้อยู่ในระบบแล้ว"
        );
      }

      if (
        formData.ar_code === initialFormData.ar_code &&
        formData.ar_name === initialFormData.ar_name &&
        formData.ar_type === initialFormData.ar_type &&
        formData.ar_shortname === initialFormData.ar_shortname &&
        formData.ar_taxno === initialFormData.ar_taxno &&
        formData.ar_add1 === initialFormData.ar_add1 &&
        formData.ar_add2 === initialFormData.ar_add2 &&
        formData.ar_add3 === initialFormData.ar_add3 &&
        formData.ar_province === initialFormData.ar_province &&
        formData.ar_zipcode === initialFormData.ar_zipcode &&
        formData.ar_contact === initialFormData.ar_contact &&
        formData.ar_contact2 === initialFormData.ar_contact2 &&
        formData.ar_tel1 === initialFormData.ar_tel1 &&
        formData.ar_tel2 === initialFormData.ar_tel2 &&
        formData.ar_group === initialFormData.ar_group &&
        formData.ar_refsalecode === initialFormData.ar_refsalecode &&
        formData.ar_area === initialFormData.ar_area &&
        formData.ar_status === initialFormData.ar_status &&
        formData.ar_credit === initialFormData.ar_credit &&
        formData.ar_vat === initialFormData.ar_vat &&
        formData.ar_discount === initialFormData.ar_discount &&
        formData.ar_branch === initialFormData.ar_branch &&
        formData.ar_bt_name === initialFormData.ar_bt_name &&
        formData.ar_addlat === initialFormData.ar_addlat &&
        formData.ar_addlan === initialFormData.ar_addlan &&
        formData.ar_refsalename === initialFormData.ar_refsalename &&
        formData.ar_credit_term === initialFormData.ar_credit_term &&
        formData.ar_credit_limit === initialFormData.ar_credit_limit &&
        formData.ar_item_free === initialFormData.ar_item_free
      ) {
        getAlert(
          "WARNING",
          "โปรดตรวจสอบข้อมูลอีกครั้ง ข้อมูลนี้มีอยู่ในระบบแล้ว"
        );
        return;
      }
      if (mode === "I") {
        await handleInsertAR();
      } else if (mode === "U") {
        await handleUpdateAR();
      }
      setFormData({
        ar_id: "",
        comp_id: window.localStorage.getItem("company"),
        ar_code: "",
        ar_name: "",
        ar_type: "",
        ar_shortname: "",
        ar_taxno: "",
        ar_add1: "",
        ar_add2: "",
        ar_add3: "",
        ar_province: "",
        ar_zipcode: "",
        ar_contact: "",
        ar_contact2: "",
        ar_tel1: "",
        ar_tel2: "",
        ar_group: "",
        ar_refsalecode: "",
        ar_area: "",
        ar_status: "Y",
        ar_credit: 0,
        ar_vat: 0,
        ar_discount: "",
        ar_branch: "",
        ar_bt_name: "",
        ar_addlan: "",
        ar_addlat: "",
        ar_refsalename: "",
        ar_credit_term: "",
        ar_credit_limit: "",
        ar_item_free: "N",
      });
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      getAlert(
        "WARNING",
        "โปรดตรวจสอบข้อมูลอีกครั้ง ข้อมูลนี้มีอยู่ในระบบแล้ว"
      );
      return null;
    }
  };

  // Confirm wrappers
  const confirmAndSubmit = async () => {
    try {
      getAlert("C_DIALOG", "ยืนยันการบันทึกข้อมูลลูกหนี้?", async (isConfirm) => {
        if (isConfirm) {
          await handleSubmit();
        }
      });
    } catch (error) {
      console.error("confirmAndSubmit error:", error);
    }
  };

  const confirmAndUpdate = async () => {
    try {
      getAlert("C_DIALOG", "ยืนยันการอัปเดตข้อมูลลูกหนี้?", async (isConfirm) => {
        if (isConfirm) {
          await handleUpdateAR();
        }
      });
    } catch (error) {
      console.error("confirmAndUpdate error:", error);
    }
  };

  const checkArCode = async () => {

    const resItemCode = await getDataWithJoin(
      `a.*`,
      `[dbo].[Tb_Set_AR] AS a`,
      `WHERE a.AR_Code = '${formData.ar_code}'`,
      ""
    );

    if (resItemCode && resItemCode.length > 0) {
      getAlert("FAILED", "มีรหัสลูกหนี้แล้ว");
      setFormData((prev) => ({ ...prev, ar_code: "" }));
    } else {
      getAlert("SUCCESS", "รหัสลูกหนี้นี้สามารถใช้ได้");
    }
  };

  const handleIcePriceModal = async () => {
    try {
      const standardPriceData = await getDataWithComp(
        "TB_SET_ITEM",
        `AND Item_code = '102'`
      );

      if (standardPriceData && standardPriceData.length > 0) {
        setStandardPrice(standardPriceData[0].Item_Price || 0);
      } else {
        console.warn("No data found for Item_code = '102'");
        setStandardPrice(0);
      }

      if (formData.ar_id) {
        const arData = await getDataWithComp(
          "TB_SET_AR",
          `AND AR_Id = ${formData.ar_id}`
        );

        if (arData && arData.length > 0) {
          setSpecialPrice(arData[0].Default_Price || 0);
          setIsThreeBagDeal(arData[0].AR_ICE_Pro === "Pro3-1");
        } else {
          console.warn("No AR data found for AR_Id:", formData.ar_id);
          setSpecialPrice(0);
          setIsThreeBagDeal(false);
        }
      } else {
        setSpecialPrice(formData.default_price || 0);
        setIsThreeBagDeal(formData.ar_ice_pro === "Pro3-1");
      }

      setShowIcePriceModal(true);
    } catch (error) {
      console.error(
        "Error loading ice price data:",
        error.message,
        error.stack
      );
      setStandardPrice(0);
      setSpecialPrice(0);
      setIsThreeBagDeal(false);
      setShowIcePriceModal(true);
    }
  };

  const handleSaveIcePrice = async () => {
    try {
      const updatedFormData = {
        ...formData,
        default_price: specialPrice || 0,
        ar_ice_pro: isThreeBagDeal ? "Pro3-1" : "",
      };
      setFormData(updatedFormData);

      if (formData.ar_id && mode === "U") {
        const values = {
          Default_Price: specialPrice || 0,
          AR_ICE_Pro: isThreeBagDeal ? "Pro3-1" : "",
        };
        const where = { AR_Id: formData.ar_id };
        const res = await updateData("TB_SET_AR", values, where);

        if (res) {
          getAlert("OK", "บันทึกราคาน้ำแข็งสำเร็จ");
        } else {
          getAlert("FAILED", "ไม่สามารถบันทึกราคาน้ำแข็งได้");
        }
      } else {
        getAlert("OK", "บันทึกราคาน้ำแข็งในฟอร์มสำเร็จ");
      }

      setShowIcePriceModal(false);
    } catch (error) {
      console.error("Error saving ice price data:", error);
      getAlert("FAILED", "เกิดข้อผิดพลาดขณะบันทึกราคาน้ำแข็ง");
      setShowIcePriceModal(false);
    }
  };

  const closeIcePriceModal = () => {
    setShowIcePriceModal(false);
  };

  const handlePicture = async () => {
    try {
      if (formData.ar_id) {
        setShowPictureModal(true);
      } else {
        getAlert("WARNING", "กรุณาบันทึกรายการก่อน");
      }
    } catch (error) {
      console.error("Error opening picture modal:", error);
      getAlert("FAILED", "ไม่สามารถเปิดโมดอลภาพได้");
    }
  };



  return (
    <>
      <form>
        <Breadcrumbs
          isShowStatus={mode === "U"}
          items={[
            { name: "ข้อมูลตั้งต้น", url: "/initialdata" },
            { name: name, url: "/debtor" },
            {
              name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name,
              url: "#",
            },
          ]}
        />
        <div className="container py-4">
          <div className="card shadow-sm">
            <div className="card-body">
              <div className="d-flex justify-content-end mb-3">
                {localStorage.getItem("company") === "1" && (
                  <button
                    type="button"
                    className="btn btn-lg text-white"
                    onClick={handleOpenItemPriceModal}
                    style={{
                      backgroundColor: "#EF6C00",
                      borderColor: "#EF6C00",
                      padding: "10px 24px",
                      fontWeight: "600",
                      boxShadow: "0 6px 18px rgba(239,108,0,0.35)",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.filter = "brightness(0.9)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.filter = "brightness(1)";
                    }}
                  >
                    กำหนดราคาสินค้า
                  </button>
                )}
              </div>
              {/* ข้อมูลทั่วไป */}
              <h5 className="mb-3 border-bottom pb-2">ข้อมูลทั่วไป</h5>
              <div className="row g-3">
                <div className="col-md-4">
                  <label>รหัสลูกหนี้ <span style={{ color: "red" }}>*</span></label>
                  <input
                    type="text"
                    className="form-control"
                    name="ar_code"
                    value={formData.ar_code || ""}
                    onBlur={checkArCode}
                    onChange={handleChange}
                    maxLength={20}
                  />
                </div>
                <div className="col-md-4">
                  <label>เลขภาษี</label>
                  <input
                    type="text"
                    className="form-control"
                    name="ar_taxno"
                    value={formData.ar_taxno || ""}
                    onChange={handleChange}
                    maxLength={13}
                  />
                </div>
                <div className="col-md-4">
                  <label>ประเภทลูกหนี้ <span style={{ color: "red" }}>*</span></label>
                  <div className="input-group">
                    <select
                      className="form-select"
                      name="ar_type"
                      value={formData.ar_type}
                      onChange={handleChange}
                      disabled={dataARtype.length <= 0}
                    >
                      <option value="">โปรดระบุประเภทลูกหนี้</option>
                      {dataARtype.map((type, index) => (
                        <option key={index} value={type.ARType_Id}>
                          {type.ARType_Name}
                        </option>
                      ))}
                    </select>
                    {dataARtype.length <= 0 && (
                      <button
                        onClick={() => navigate("/ARtype")}
                        className="btn btn-warning text-white"
                        type="button"
                      >
                        +
                      </button>
                    )}
                  </div>
                </div>
              </div>

              {/* ชื่อลูกหนี้และชื่อย่อ */}
              <div className="row g-3 mt-3">
                <div className="col-md-6">
                  <label>ชื่อลูกหนี้ <span style={{ color: "red" }}>*</span></label>
                  <input
                    type="text"
                    className="form-control"
                    name="ar_name"
                    value={formData.ar_name || ""}
                    onChange={handleChange}
                    maxLength={200}
                  />
                </div>
                <div className="col-md-6">
                  <label>ชื่อย่อ</label>
                  <input
                    type="text"
                    className="form-control"
                    name="ar_shortname"
                    value={formData.ar_shortname || ""}
                    onChange={handleChange}
                    maxLength={50}
                  />
                </div>
              </div>

              {/* ที่อยู่ */}
              <h5 className="mt-4 mb-3 border-bottom pb-2">ที่อยู่</h5>
              <div className="row g-3">
                <div className="col-md-4">
                  <label>ที่อยู่ 1</label>
                  <input
                    type="text"
                    className="form-control"
                    name="ar_add1"
                    value={formData.ar_add1 || ""}
                    onChange={handleChange}
                    maxLength={150}
                  />
                </div>
                <div className="col-md-4">
                  <label>ที่อยู่ 2</label>
                  <input
                    type="text"
                    className="form-control"
                    name="ar_add2"
                    value={formData.ar_add2 || ""}
                    onChange={handleChange}
                    maxLength={150}
                  />
                </div>
                <div className="col-md-4">
                  <label>ที่อยู่ 3</label>
                  <input
                    type="text"
                    className="form-control"
                    name="ar_add3"
                    value={formData.ar_add3 || ""}
                    onChange={handleChange}
                    maxLength={150}
                  />
                </div>
                <div className="col-md-4">
                  <label>จังหวัด</label>
                  <input
                    type="text"
                    className="form-control"
                    name="ar_province"
                    value={formData.ar_province || ""}
                    onChange={handleChange}
                    maxLength={50}
                  />
                </div>
                <div className="col-md-4">
                  <label>รหัสไปรษณีย์</label>
                  <input
                    type="text"
                    className="form-control"
                    name="ar_zipcode"
                    value={formData.ar_zipcode || ""}
                    onChange={handleChange}
                    maxLength={5}
                  />
                </div>
                <div className="col-md-4">
                  <label>กลุ่ม</label>
                  <input
                    type="text"
                    className="form-control"
                    name="ar_group"
                    value={formData.ar_group || ""}
                    onChange={handleChange}
                    maxLength={50}
                  />
                </div>
              </div>

              {/* ข้อมูลการติดต่อ */}
              <h5 className="mt-4 mb-3 border-bottom pb-2">ข้อมูลการติดต่อ</h5>
              <div className="row g-3">
                <div className="col-md-6">
                  <label>ติดต่อ</label>
                  <input
                    type="text"
                    className="form-control"
                    name="ar_contact1"
                    value={formData.ar_contact1 || ""}
                    onChange={handleChange}
                    maxLength={100}
                  />
                </div>
                <div className="col-md-6">
                  <label>ติดต่อ 2</label>
                  <input
                    type="text"
                    className="form-control"
                    name="ar_contact2"
                    value={formData.ar_contact2 || ""}
                    onChange={handleChange}
                    maxLength={100}
                  />
                </div>
                <div className="col-md-6">
                  <label>เบอร์โทร</label>
                  <input
                    type="text"
                    className="form-control"
                    name="ar_tel1"
                    value={formData.ar_tel1 || ""}
                    onChange={handleChange}
                    maxLength={100}
                  />
                </div>
                <div className="col-md-6">
                  <label>เบอร์โทร 2</label>
                  <input
                    type="text"
                    className="form-control"
                    name="ar_tel2"
                    value={formData.ar_tel2 || ""}
                    onChange={handleChange}
                    maxLength={100}
                  />
                </div>
              </div>

              {/* พื้นที่และสาขา */}
              <h5 className="mt-4 mb-3 border-bottom pb-2">พื้นที่/สาขา</h5>
              <div className="row g-3">
                <div className="col-md-4">
                  <label>พื้นที่</label>
                  <input
                    type="text"
                    className="form-control"
                    name="ar_area"
                    value={formData.ar_area || ""}
                    onChange={handleChange}
                    maxLength={20}
                  />
                </div>
                <div className="col-md-4">
                  <label>สาขา</label>
                  <input
                    type="text"
                    className="form-control"
                    name="ar_branch"
                    value={formData.ar_branch || ""}
                    onChange={handleChange}
                    maxLength={100}
                  />
                </div>
                <div className="col-md-4">
                  <label>ชื่อสาขา</label>
                  <input
                    type="text"
                    className="form-control"
                    name="ar_bt_name"
                    value={formData.ar_bt_name || ""}
                    onChange={handleChange}
                    maxLength={100}
                  />
                </div>
              </div>

              {/* พิกัด */}
              <h5 className="mt-4 mb-3 border-bottom pb-2">พิกัดที่อยู่</h5>
              <div className="row g-3">
                <div className="col-md-6">
                  <label>ละติจูด</label>
                  <input
                    type="text"
                    className="form-control"
                    name="ar_addlat"
                    value={formData.ar_addlat || ""}
                    onChange={handleChange}
                    maxLength={50}
                  />
                </div>
                <div className="col-md-6">
                  <label>ลองจิจูด</label>
                  <input
                    type="text"
                    className="form-control"
                    name="ar_addlan"
                    value={formData.ar_addlan || ""}
                    onChange={handleChange}
                    maxLength={50}
                  />
                </div>
              </div>

              {/* ข้อมูลทางการเงิน */}
              <h5 className="mt-4 mb-3 border-bottom pb-2">ข้อมูลทางการเงิน</h5>
              <div className="row g-3">
                <div className="col-md-3">
                  <label>การลดราคา</label>
                  <CurrencyInput
                    className="form-control text-end"
                    name="ar_discount"
                    value={formData.ar_discount || ""}
                    decimalsLimit={2}
                    allowNegativeValue={false}
                    onValueChange={(value, name) =>
                      handleCurrencyChange(value, name)
                    }
                  />
                </div>
                <div className="col-md-3">
                  <label>ภาษีมูลค่าเพิ่ม</label>
                  <CurrencyInput
                    className="form-control text-end"
                    name="ar_vat"
                    value={formData.ar_vat || ""}
                    decimalsLimit={2}
                    allowNegativeValue={false}
                    onValueChange={(value, name) =>
                      handleCurrencyChange(value, name)
                    }
                  />
                </div>
                <div className="col-md-3">
                  <label>เครดิต</label>
                  <CurrencyInput
                    className="form-control text-end"
                    name="ar_credit"
                    value={formData.ar_credit || ""}
                    decimalsLimit={2}
                    allowNegativeValue={false}
                    onValueChange={(value, name) =>
                      handleCurrencyChange(value, name)
                    }
                  />
                </div>
                <div className="col-md-3">
                  <label>ระยะเวลาเครดิตลูกค้า</label>
                  <CurrencyInput
                    className="form-control text-end"
                    name="ar_credit_term"
                    value={formData.ar_credit_term || ""}
                    decimalsLimit={0}
                    allowNegativeValue={false}
                    onValueChange={(value, name) =>
                      handleCurrencyChange(value, name)
                    }
                  />
                </div>
              </div>

              {/* แถวที่สอง - ยอดเครดิตและปุ่ม */}
              <div className="row g-3 mt-3">
                <div className="col-md-3">
                  <label>ยอดเครดิตลูกค้า</label>
                  <div className="input-group">
                    <CurrencyInput
                      className="form-control text-end"
                      name="ar_credit_limit"
                      value={formData.ar_credit_limit || ""}
                      decimalsLimit={2}
                      allowNegativeValue={false}
                      onValueChange={(value, name) =>
                        handleCurrencyChange(value, name)
                      }
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <label className="d-block">&nbsp;</label>
                  <div className="d-flex gap-2">
                    {formData.comp_id === "2" && (
                      <button
                        className="btn btn-warning text-white"
                        type="button"
                        onClick={handleIcePriceModal}
                        style={{ minHeight: "38px", minWidth: "100px" }}
                      >
                        ราคาน้ำแข็ง
                      </button>
                    )}
                    <button
                      className="btn btn-info text-white"
                      type="button"
                      onClick={handlePicture}
                      style={{ minHeight: "38px", minWidth: "100px" }}
                    >
                      รูปภาพหน้าร้าน
                    </button>
                  </div>
                </div>
              </div>

              {/* สถานะลูกค้า */}
              <h5 className="mt-4 mb-3 border-bottom pb-2">สถานะลูกค้า</h5>
              <div className="row g-3">
                <div className="col-md-3">
                  <label>สถานะ <span style={{ color: "red" }}>*</span></label>
                  <select
                    className="form-select"
                    name="ar_status"
                    value={formData.ar_status || "Y"}
                    onChange={handleChange}
                  >
                    <option value="Y">ใช้งาน</option>
                    <option value="N">ไม่ใช้งาน</option>
                  </select>
                </div>
                <div className="col-md-3">
                  <label>ลูกค้าฟรี</label>
                  <select
                    className="form-select"
                    name="ar_item_free"
                    value={formData.ar_item_free}
                    onChange={handleChange}
                  >
                    <option value="">กรุณาระบุลูกค้าฟรี</option>
                    <option value="N">ไม่ฟรี</option>
                    <option value="Y">ฟรี</option>
                  </select>
                </div>
              </div>

              {/* ปุ่ม */}
              <div className="row mt-4">
                {mode !== "I" ? (
                  <div className="d-flex justify-content-between align-items-center">
                    <button
                      onClick={handleDelete}
                      type="button"
                      className="btn btn-danger btn-lg"
                    >
                      ลบ
                    </button>
                    <div className="d-flex gap-2">
                      <button
                        onClick={() => onCancel?.()}
                        type="button"
                        className="btn btn-dark btn-lg"
                      >
                        ยกเลิก (ESC)
                      </button>
                      <button
                        onClick={confirmAndUpdate}
                        type="button"
                        className="btn btn-warning text-white btn-lg"
                      >
                        บันทึก (F10)
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="d-flex justify-content-between align-items-center">
                    <div></div>
                    <div className="d-flex gap-2">
                      <button
                        onClick={() => onCancel?.()}
                        type="button"
                        className="btn btn-dark btn-lg"
                      >
                        ยกเลิก (ESC)
                      </button>
                      <button
                        onClick={confirmAndSubmit}
                        type="button"
                        className="btn btn-warning text-white btn-lg"
                      >
                        บันทึก (F10)
                      </button>
                    </div>
                  </div>
                )}
              </div>

              {/* Keyboard Instructions */}
              <div className="row mt-3">
                <div className="col-12">
                  <div className="text-muted" style={{ fontSize: "12px" }}>
                    <strong>คีย์ลัด:</strong> ESC = ยกเลิก | F10 = บันทึก
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>

      {/* Item Price Modal */}
      {showItemPriceModal && (
        <>
          <div
            className="modal fade show"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.45)" }}
            tabIndex="-1"
          >
            <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
              <div
                className="modal-content border-0 shadow"
                style={{ backgroundColor: "#fffefb" }}
              >
                <div className="modal-header border-bottom-0 bg-white">
                  <div>
                    <h4 className="modal-title mb-1 text-dark">
                      กำหนดราคาสินค้า
                    </h4>
                  </div>
                  <button
                    type="button"
                    className="btn btn-lg text-white"
                    onClick={() => setShowItemModal(true)}
                    style={{
                      backgroundColor: "#EF6C00",
                      borderColor: "#EF6C00",
                      padding: "8px 20px",
                      fontWeight: "600",
                      boxShadow: "0 4px 12px rgba(239,108,0,0.4)",
                    }}
                  >
                    <i className="fas fa-plus me-1"></i> เลือกสินค้า
                  </button>
                </div>
                <div className="modal-body pt-0" style={{ backgroundColor: "#fffdf7" }}>
                  <div className="table-responsive rounded-3 overflow-hidden border">
                    <table className="table table-hover mb-0">
                      <thead
                        style={{
                          backgroundColor: "#EF6C00",
                          color: "#fff",
                        }}
                      >
                        <tr>
                          <th className="text-center text-white">รหัสสินค้า</th>
                          <th className="text-center text-white">ชื่อสินค้า</th>
                          <th className="text-center text-white">ราคาที่กำหนด</th>
                          <th className="text-center text-white">จัดการ</th>
                        </tr>
                      </thead>
                      <tbody>
                        {itemPriceRows.length === 0 ? (
                          <tr>
                            <td className="text-center" colSpan="4">
                              ไม่พบข้อมูล
                            </td>
                          </tr>
                        ) : (
                          itemPriceRows.map((row) => (
                            <tr key={row.Item_Id}>
                              <td className="text-center text-secondary">
                                {row.Item_Code || "-"}
                              </td>
                              <td className="text-start"
                                style={{ minWidth: "300px" }}>{row.Item_Name || "-"}</td>
                              <td
                                className="align-middle"
                              >
                                <CurrencyInput
                                  className="form-control form-control-sm text-end"
                                  value={row.Item_Price || 0}
                                  decimalsLimit={2}
                                  allowNegativeValue={false}
                                  onValueChange={(value) =>
                                    handleItemPriceChange(row.Item_Id, value)
                                  }
                                  onFocus={() => handleItemPriceFocus(row.Item_Id)}
                                  onBlur={(e) =>
                                    handleItemPriceBlur(row.Item_Id, e.target.value)
                                  }
                                />
                              </td>
                              <td className="text-center">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger"
                                  onClick={() =>
                                    handleRemoveItemRow(
                                      row.Item_Id,
                                      row.Item_Price_Id
                                    )
                                  }
                                >
                                  ลบ
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="modal-footer border-top-0 bg-white">
                  <button
                    type="button"
                    className="btn btn-danger btn-lg px-4"
                    onClick={closeItemPriceModal}
                  >
                    ยกเลิก
                  </button>
                  <button
                    type="button"
                    className="btn btn-success btn-lg text-white px-4"
                    onClick={handleSaveItemPrices}
                    disabled={isSavingItemPrice}
                  >
                    {isSavingItemPrice ? "กำลังบันทึก..." : "บันทึก"}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}
      <ItemModal
        formDetailList={itemPriceRows}
        showItemModal={showItemModal}
        handleItemClose={() => setShowItemModal(false)}
        itemDataList={itemDataList}
        onRowSelectItem={handleSelectedItems}
      />
      {/* Ice Price Modal */}
      {showIcePriceModal && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">ราคาน้ำแข็ง</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeIcePriceModal}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="row g-3">
                  <div className="col-12">
                    <label className="form-label">ราคามาตรฐาน</label>
                    <input
                      type="text"
                      className="form-control text-end"
                      value={standardPrice}
                      readOnly
                      style={{ backgroundColor: "#f8f9fa" }}
                    />
                  </div>

                  <div className="col-12">
                    <label className="form-label">ราคาพิเศษ</label>
                    <div className="input-group">
                      <CurrencyInput
                        className="form-control text-end"
                        value={specialPrice}
                        decimalsLimit={2}
                        allowNegativeValue={false}
                        onValueChange={(value) => setSpecialPrice(value || 0)}
                      />
                      <span className="input-group-text">
                        (0.00 ใช้ราคามาตรฐาน)
                      </span>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="threeBagDeal"
                        checked={isThreeBagDeal}
                        onChange={(e) => setIsThreeBagDeal(e.target.checked)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="threeBagDeal"
                      >
                        3 กระสอบ 100
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeIcePriceModal}
                >
                  ปิด
                </button>
                <button
                  type="button"
                  className="btn btn-warning text-white"
                  onClick={handleSaveIcePrice}
                >
                  บันทึก
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showPictureModal && (
        <ArImage
          onClose={() => setShowPictureModal(false)}
          isOpen={showPictureModal}
          arId={formData.ar_id}
        />
      )}
    </>
  );
};

export default Form;
